import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "speaker" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "screen" }

import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { UISpin } from '@gohighlevel/ghl-ui'
import IframeComponent from 'common/components/Preview/IframeComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Devices',
  props: {
  html: {
    type: String,
    default: '',
  },
  device: {
    type: String,
    default: 'mobile',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["marvel-device", __props.device])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (__props.html)
          ? (_openBlock(), _createBlock(IframeComponent, {
              key: 0,
              html: __props.html,
              style: {"width":"100%","border":"none","height":"100%"}
            }, null, 8 /* PROPS */, ["html"]))
          : (_openBlock(), _createBlock(_unref(UISpin), { key: 1 }))
      ])
    ], 2 /* CLASS */)
  ]))
}
}

})